const EcosiaUser = require('@ecosia/ecosia-user');

const { MAIN } = require('../../constants/cookies');

module.exports = (req) => {
  if (req.user) {
    return req.user;
  }

  const acceptLanguage = req.headers['accept-language'];
  const cookieString = req.cookies.get(MAIN, { parseJSON: false });
  const userAgent = req.headers['user-agent'];
  const user = new EcosiaUser({ cookieString, acceptLanguage, userAgent });

  const urlParams = new URLSearchParams(req.url);
  const addOn = urlParams.get('addon');
  if (addOn) {
    user.set('addOn', 1);
  }

  const isEcosiaApp = userAgent?.includes('Ecosia ios') || userAgent?.includes('Ecosia android');
  user.set('isEcosiaApp', isEcosiaApp);

  return user;
};
